import { doc, DocumentSnapshot, getDoc } from 'firebase/firestore'
import { channel } from 'redux-saga'
import { ChannelTakeEffect, put, take, takeEvery } from 'redux-saga/effects'
import PrivacyPolicy from 'redux/models/privacyPolicy'
import Terms from 'redux/models/terms'
import * as Application from 'redux/modules/application'
import { firestore } from 'utils/firebaseApp'

const redirectChannel = channel()

const loadTerms = function* () {
  const docRef: DocumentSnapshot = yield getDoc(doc(firestore, 'constants', 'terms'))
  const terms = Terms.load(docRef.id, docRef.data())

  if (terms) {
    yield put(Application.actions.setTerms(terms))
  }
}

const loadPrivacyPolicy = function* () {
  const docRef: DocumentSnapshot = yield getDoc(doc(firestore, 'constants', 'privacyPolicy'))
  const privacyPolicy = PrivacyPolicy.load(docRef.id, docRef.data())

  if (privacyPolicy) {
    yield put(Application.actions.setPrivacyPolicy(privacyPolicy))
  }
}

export default function* dataSaga() {
  yield takeEvery(Application.LOAD_TERMS, loadTerms)
  yield takeEvery(Application.LOAD_PRIVACY_POLICY, loadPrivacyPolicy)

  while (true) {
    const action: ChannelTakeEffect<unknown> = yield take(redirectChannel)
    yield put(action)
  }
}
